import { render } from "./SiteSelfSettings.vue?vue&type=template&id=0de08faf&scoped=true"
import script from "./SiteSelfSettings.vue?vue&type=script&lang=js"
export * from "./SiteSelfSettings.vue?vue&type=script&lang=js"

import "./SiteSelfSettings.vue?vue&type=style&index=0&id=0de08faf&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de08faf"]])

export default __exports__